// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CookieConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/CookieConstants.mjs";
import * as LocaleConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/LocaleConstants.mjs";

var categories_necessary = {
  enabled: true,
  readOnly: true,
  autoClear: {
    cookies: [
      {
        name: CookieConstants$PorterinUtils.dd_cookie
      },
      {
        name: CookieConstants$PorterinUtils.web_tracking_id
      },
      {
        name: CookieConstants$PorterinUtils.delivery_ck
      }
    ],
    reloadPage: true
  }
};

var categories_analytics_and_performance = {
  enabled: false,
  readOnly: false,
  autoClear: {
    cookies: [
      {
        name: CookieConstants$PorterinUtils.ga_cookie
      },
      {
        name: CookieConstants$PorterinUtils.gid_cookie
      },
      {
        name: CookieConstants$PorterinUtils.ga_cookie_with_id
      }
    ],
    reloadPage: true
  }
};

var categories_marketing = {
  enabled: false,
  readOnly: false,
  autoClear: {
    cookies: [{
        name: CookieConstants$PorterinUtils.fb_cookie
      }],
    reloadPage: true
  }
};

var categories_functional = {
  enabled: false,
  readOnly: false,
  autoClear: {
    cookies: [{
        name: CookieConstants$PorterinUtils.next_locale
      }],
    reloadPage: true
  }
};

var categories = {
  necessary: categories_necessary,
  analytics_and_performance: categories_analytics_and_performance,
  marketing: categories_marketing,
  functional: categories_functional
};

var translations = {
  defaultLocale: LocaleConstants$PorterinUtils.tr_default
};

export {
  categories ,
  translations ,
}
/* No side effect */
